<template>
    <teleport to="#teleport-dialog">
        <TransitionModal>
            <Fixed
                v-if="isOpen"
                class="fixed"
                @close="close"
                @click.prevent.stop="close"
            >
                <div
                    class="th-dialog"
                    role="dialog"
                    aria-modal="true"
                    :aria-label="prompt"
                >
                    <div class="header">
                        <ButtonRound
                            :icon="'close'"
                            class="button-navigation right"
                            type="link"
                            @click.prevent.stop="close"
                        />
                    </div>

                    <div class="body">
                        {{ prompt }}
                    </div>

                    <div class="controls">
                        <ThButton
                            :data-qa="'confirm'"
                            @click="confirm"
                        >
                            {{ confirmLabel }}
                        </ThButton>

                        <ThButton
                            :data-qa="'cancel'"
                            class="cancel"
                            @click="close"
                        >
                            {{ cancelLabel }}
                        </ThButton>
                    </div>
                </div>
            </Fixed>
        </TransitionModal>
    </teleport>
</template>

<script setup lang="ts">
import Fixed from './Fixed.vue'
import TransitionModal from './TransitionModal.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'
import ButtonRound from '@/components/ui/buttons/ButtonRound.vue'

withDefaults(
    defineProps<{
        isOpen: boolean
        prompt: string
        confirmLabel?: string
        cancelLabel?: string
    }>(),
    {
        confirmLabel: 'Confirm',
        cancelLabel: 'Cancel',
    }
)

const emit = defineEmits<{
    confirm: []
    close: []
}>()

const confirm = () => {
    emit('confirm')
}

const close = () => {
    emit('close')
}
</script>

<style lang="scss" scoped>
.fixed {
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.th-dialog {
    max-width: 100%;
    padding: 16px 32px 32px;
    background-color: $white;
    box-shadow: 0 0 20px rgba($black, 0.1);

    .header {
        margin-bottom: 16px;
        display: flex;
        justify-content: flex-end;
    }

    .body {
        margin-bottom: 32px;
    }

    .controls {
        display: flex;
        justify-content: space-between;
    }
}
</style>
